<script>

import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import medicionFrecuenciaAPI from "@/services/standards/medicionFrecuencia/medicionFrecuenciaAPI"
import CheckModal from "@/components/CheckModal";
import { downloadLineChartImage } from "@/utils/helpers/chartImage";

/**
 * Form elements component
 */
export default {
  page: {
    title: "3.3.2 Medición de la frecuencia de la accidentalidad",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    CheckModal,
    Layout,
    Style,
    PageHeader,
  },
  data() {

    return {
      title: "3.3.2 Medición de la frecuencia de la accidentalidad",
      items: [

        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "3.3.2 Medición de la frecuencia de la accidentalidad",
          active: true,
        },
      ],
      years: [],
      show: [],

      listY: [],
      listM: [],

      chartOptions: {
        lineSmooth: false,
      },

      chartData1: {
        labels: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
        series: [
          [],
          [],
        ],
      },

      chartData: {
        labels: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
        series: [
          [],
        ],
      },

      chartData2: {
        labels: [],
        series: [
          [],
          [],
          [],
          [],
          [],
        ],
      },

      chartData3: {
        labels: [],
        series: [
          [],
          [],
          [],
          [],
          [],
        ],
      },

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,

      meses: [
        {
          id: 1,
          name: "Enero"
        },
        {
          id: 2,
          name: "Febrero"
        },
        {
          id: 3,
          name: "Marzo"
        },
        {
          id: 4,
          name: "Abril"
        },
        {
          id: 5,
          name: "Mayo"
        },
        {
          id: 6,
          name: "Junio"
        },
        {
          id: 7,
          name: "Julio"
        },
        {
          id: 8,
          name: "Agosto"
        },
        {
          id: 9,
          name: "Septiembre"
        },
        {
          id: 10,
          name: "Octubre"
        },
        {
          id: 11,
          name: "Noviembre"
        },
        {
          id: 12,
          name: "Diciembre"
        },
      ],

      unoA: null,
      dosA: null,
      tresA: null,
      cuatroA: null,
      cincoA: null,
      seisA: null,
      sieteA: null,
      ochoA: null,
      nueveA: null,
      diezA: null,

      unoC: null,
      dosC: null,
      tresC: null,
      cuatroC: null,
      cincoC: null,
      seisC: null,
      sieteC: null,
      ochoC: null,
      nueveC: null,
      diezC: null,

      //-------//
      january_a: null,
      february_a: null,
      march_a: null,
      april_a: null,
      may_a: null,
      june_a: null,
      july_a: null,
      august_a: null,
      september_a: null,
      october_a: null,
      november_a: null,
      december_a: null,
      //-------//

      january_p: null,
      february_p: null,
      march_p: null,
      april_p: null,
      may_p: null,
      june_p: null,
      july_p: null,
      august_p: null,
      september_p: null,
      october_p: null,
      november_p: null,
      december_p: null,
      //-------//
      january_a: null,
      february_a: null,
      march_a: null,
      april_a: null,
      may_a: null,
      june_a: null,
      july_a: null,
      august_a: null,
      september_a: null,
      october_a: null,
      november_a: null,
      december_a: null,
      //-------//
      january_t: null,
      february_t: null,
      march_t: null,
      april_t: null,
      may_t: null,
      june_t: null,
      july_t: null,
      august_t: null,
      september_t: null,
      october_t: null,
      november_t: null,
      december_t: null,

      january_i: null,
      february_i: null,
      march_i: null,
      april_i: null,
      may_i: null,
      june_i: null,
      july_i: null,
      august_i: null,
      september_i: null,
      october_i: null,
      november_i: null,
      december_i: null,
      //-------//
      january_c: null,
      february_c: null,
      march_c: null,
      april_c: null,
      may_c: null,
      june_c: null,
      july_c: null,
      august_c: null,
      september_c: null,
      october_c: null,
      november_c: null,
      december_c: null,
      //-------//
      january_an: null,
      february_an: null,
      march_an: null,
      april_an: null,
      may_an: null,
      june_an: null,
      july_an: null,
      august_an: null,
      september_an: null,
      october_an: null,
      november_an: null,
      december_an: null,

      january_m: null,
      february_m: null,
      march_m: null,
      april_m: null,
      may_m: null,
      june_m: null,
      july_m: null,
      august_m: null,
      september_m: null,
      october_m: null,
      november_m: null,
      december_m: null,

      selected: null,

      medicionY: {
        year: null,
        companie_id: this.$store.getters["company/getCompany"].id || null,
      },

      medicionM: {
        start_year: null,
        end_year: null,
        companie_id: this.$store.getters["company/getCompany"].id || null,
      },
    };
  },
  methods: {

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
   * This method is used to knows if the user has the permission indicated
   * @param {String} name The name of the permission
   * @param {Array} roles the roles that permitted to access the action 
   * @returns {Boolean} true if the user has the permission indicated or false if no
   */
    getRole(name, roles) {

      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null

      // If the user is logged
      if (role) {

        // If the roles array is not empty
        if (roles) {

          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false

        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {

          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8

        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions

        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false

      } // Close if the user is logged

      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },


    saveY() {
      medicionFrecuenciaAPI.saveY(this.medicionY)
        .then((response) => {
          let medicion = response;
          this.listY = medicion;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    show(id) {
      medicionFrecuenciaAPI.show(id)
        .then((response) => {
          let medicion = response;
          this.show = medicion;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async todos() {
      this.getGrafica()
      this.saveY()
    },

    async todos2() {
      this.getGrafica2()
      this.saveM()
    },

    getGrafica2() {
      this.chartData2.labels = []
      this.chartData2.series[0] = []

      this.chartData3.labels = []
      this.chartData3.series[1] = []

      medicionFrecuenciaAPI.saveYears(this.medicionM)
        .then((response) => {
          let medicion = response;
          this.listM = medicion;
          for (let i = 0; i <= this.listM.length; i++) {
            this.chartData2.labels.push(this.listM[i].Periodo)

            this.chartData3.labels.push(this.listM[i].Periodo)

            this.chartData2.series[0].push(this.listM[i].Indicador_Frecuencia)

            this.chartData3.series[1].push(this.listM[i].Accidentes_year)
          }

        })
        .catch((error) => {
          console.log(error);
        });
    },

    getGrafica() {
      medicionFrecuenciaAPI.saveY(this.medicionY)
        .then((response) => {
          let medicion = response;
          this.listY = medicion;
          for (let i = 0; i <= 11; i++) {
            if (this.listY[i].Periodo === 'enero') {
              this.january_p = this.listY[i].Periodo;
              this.january_a = this.listY[i].Accidentes_Mensuales
              this.january_t = this.listY[i].Total_Colaboradores
              this.january_i = this.listY[i].Indicador_Frecuencia
              this.january_c = this.listY[i].Cumple
              this.january_an = this.listY[i].annual_goal
              this.january_m = this.listY[i].monthly_goal
            } else if (this.listY[i].Periodo === 'febrero') {
              this.february_p = this.listY[i].Periodo;
              this.february_a = this.listY[i].Accidentes_Mensuales
              this.february_t = this.listY[i].Total_Colaboradores
              this.february_i = this.listY[i].Indicador_Frecuencia
              this.february_c = this.listY[i].Cumple
              this.february_an = this.listY[i].annual_goal
              this.february_m = this.listY[i].monthly_goal
            } else if (this.listY[i].Periodo === 'marzo') {
              this.march_p = this.listY[i].Periodo;
              this.march_a = this.listY[i].Accidentes_Mensuales
              this.march_t = this.listY[i].Total_Colaboradores
              this.march_i = this.listY[i].Indicador_Frecuencia
              this.march_c = this.listY[i].Cumple
              this.march_an = this.listY[i].annual_goal
              this.march_m = this.listY[i].monthly_goal
            } else if (this.listY[i].Periodo === 'abril') {
              this.april_p = this.listY[i].Periodo;
              this.april_a = this.listY[i].Accidentes_Mensuales
              this.april_t = this.listY[i].Total_Colaboradores
              this.april_i = this.listY[i].Indicador_Frecuencia
              this.april_c = this.listY[i].Cumple
              this.april_an = this.listY[i].annual_goal
              this.april_m = this.listY[i].monthly_goal
            } else if (this.listY[i].Periodo === 'mayo') {
              this.may_p = this.listY[i].Periodo;
              this.may_a = this.listY[i].Accidentes_Mensuales
              this.may_t = this.listY[i].Total_Colaboradores
              this.may_i = this.listY[i].Indicador_Frecuencia
              this.may_c = this.listY[i].Cumple
              this.may_an = this.listY[i].annual_goal
              this.may_m = this.listY[i].monthly_goal
            } else if (this.listY[i].Periodo === 'junio') {
              this.june_p = this.listY[i].Periodo;
              this.june_a = this.listY[i].Accidentes_Mensuales
              this.june_t = this.listY[i].Total_Colaboradores
              this.june_i = this.listY[i].Indicador_Frecuencia
              this.june_c = this.listY[i].Cumple
              this.june_an = this.listY[i].annual_goal
              this.june_m = this.listY[i].monthly_goal
            } else if (this.listY[i].Periodo === 'julio') {
              this.july_p = this.listY[i].Periodo;
              this.july_a = this.listY[i].Accidentes_Mensuales
              this.july_t = this.listY[i].Total_Colaboradores
              this.july_i = this.listY[i].Indicador_Frecuencia
              this.july_c = this.listY[i].Cumple
              this.july_an = this.listY[i].annual_goal
              this.july_m = this.listY[i].monthly_goal
            } else if (this.listY[i].Periodo === 'agosto') {
              this.august_p = this.listY[i].Periodo;
              this.august_a = this.listY[i].Accidentes_Mensuales
              this.august_t = this.listY[i].Total_Colaboradores
              this.august_i = this.listY[i].Indicador_Frecuencia
              this.august_c = this.listY[i].Cumple
              this.august_an = this.listY[i].annual_goal
              this.august_m = this.listY[i].monthly_goal
            } else if (this.listY[i].Periodo === 'septiembre') {
              this.september_p = this.listY[i].Periodo;
              this.september_a = this.listY[i].Accidentes_Mensuales
              this.september_t = this.listY[i].Total_Colaboradores
              this.september_i = this.listY[i].Indicador_Frecuencia
              this.september_c = this.listY[i].Cumple
              this.september_an = this.listY[i].annual_goal
              this.september_m = this.listY[i].monthly_goal
            } else if (this.listY[i].Periodo === 'octubre') {
              this.october_p = this.listY[i].Periodo;
              this.october_a = this.listY[i].Accidentes_Mensuales
              this.october_t = this.listY[i].Total_Colaboradores
              this.october_i = this.listY[i].Indicador_Frecuencia
              this.october_c = this.listY[i].Cumple
              this.october_an = this.listY[i].annual_goal
              this.october_m = this.listY[i].monthly_goal
            } else if (this.listY[i].Periodo === 'noviembre') {
              this.november_p = this.listY[i].Periodo;
              this.november_a = this.listY[i].Accidentes_Mensuales
              this.november_t = this.listY[i].Total_Colaboradores
              this.november_i = this.listY[i].Indicador_Frecuencia
              this.november_c = this.listY[i].Cumple
              this.november_an = this.listY[i].annual_goal
              this.november_m = this.listY[i].monthly_goal
            } else if (this.listY[i].Periodo === 'diciembre') {
              this.december_p = this.listY[i].Periodo;
              this.december_a = this.listY[i].Accidentes_Mensuales
              this.december_t = this.listY[i].Total_Colaboradores
              this.december_i = this.listY[i].Indicador_Frecuencia
              this.december_c = this.listY[i].Cumple
              this.december_an = this.listY[i].annual_goal
              this.december_m = this.listY[i].monthly_goal
            }

          }

          const indicador = [this.january_i, this.february_i, this.march_i, this.april_i, this.may_i, this.june_i, this.july_i, this.august_i, this.september_i, this.october_i, this.november_i, this.december_i]
          this.chartData.series[0] = indicador

          const accidentesM = [this.january_a, this.february_a, this.march_a, this.april_a, this.may_a, this.june_a, this.july_a, this.august_a, this.september_a, this.october_a, this.november_a, this.december_a]
          this.chartData1.series[1] = accidentesM

        })
        .catch((error) => {
          console.log(error);
        });
    },



    saveM() {
      medicionFrecuenciaAPI.saveYears(this.medicionM)
        .then((response) => {
          let medicion = response;
          this.listM = medicion;
        })
        .catch((error) => {
          console.log(error);
        });
    },


    rangeYear() {
      const max = 2040
      const min = 2019

      for (let i = min; i <= max; i++) {
        this.years.push(i)
      }
      return this.years
    },

    goPage(page) {
      window.location.href = page
    },

    async printExcel() {
      try {
        medicionFrecuenciaAPI
          .getExcel(this.companyID, this.medicionY.year)
          .then((response) => {
            window.location.href = response;
          });
      } catch (error) {
        console.log(error);
      }
    },

    downloadMonthlyIndicatorChartImage() {
      downloadLineChartImage(
        this.chartData.labels,
        [{ data: this.chartData.series[0], label: "Frecuencia de accidentalidad" }],
        `frecuencia-mensual-indicador-${this.medicionY.year}`
      );
    },

    downloadMonthlyAccidentsChartImage() {
      downloadLineChartImage(
        this.chartData1.labels,
        [{ data: this.chartData1.series[1], label: "Total de accidentes de trabajo mensuales" }],
        `frecuencia-mensual-accidentes-${this.medicionY.year}`
      );
    },

    downloadAnnualIndicatorChartImage() {
      downloadLineChartImage(
        this.chartData2.labels,
        [{ data: this.chartData2.series[0], label: "Frecuencia de accidentalidad" }],
        `frecuencia-anual-indicador-${this.medicionM.start_year}-${this.medicionM.end_year}`
      );
    },

    downloadAnnualAccidentsChartImage() {
      downloadLineChartImage(
        this.chartData3.labels,
        [{ data: this.chartData3.series[1], label: "Total de accidentes de trabajo anuales" }],
        `frecuencia-anual-accidentes-${this.medicionM.start_year}-${this.medicionM.end_year}`
      );
    },

  },

  mounted() {
    this.rangeYear();
    this.getGrafica();
    this.todos();
    this.todos2();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12  m-0 p-0">
        <div class="card">
          <div class="card-body  ">
            <div class="row">
              <div class="col-md-6 col-sm-12">

                <CheckModal>
                  <p class="text-justify">
                    Este indicador permite calcular la cantidad de veces que ocurre un accidente de trabajo en el mes en
                    la empresa.
                  </p>
                  <p class="text-justify">
                    El responsable de la implementación deberá definir la meta mensual y anual, además el responsable de
                    la medición y las personas que deben conocer el resultado.
                  </p>
                  <p class="text-justify">
                    En este ítem podrá encontrar la ficha del indicador de frecuencia de la accidentalidad, además
                    visualizar el cálculo de este en un periodo determinado.
                  </p>
                </CheckModal>
              </div>

              <div class="col-6 text-right m-b-0">

                <button @click="
                  goPage(`/forms/estandares/${companyID}/medicion-frecuencia`)
                  " class="btn btn-primary mx-1">
                  <span class="btn-label"> </span> Parametrizar periodos
                </button>

              </div>


            </div>

            <hr>

            <div class="row pt-3">
              <b-form-group label="Seleccionar Periodicidad" label-for="¿Evaluada el ultimo año?" inline
                class="col-sm-4 pl-3">
                <label class="mr-2 pl-sm-2 pl-md-0">
                  Mensual
                </label>
                <input type="radio" :value="2" class="mb-2 mr-sm-2 mb-sm-0" label="incidente" v-model="selected" />
                <label class="mr-2">
                  Anual
                </label>
                <input type="radio" style="color: #666" :value="1" class="mb-2 mr-sm-2 mb-sm-0" label="accidente"
                  v-model="selected" />

              </b-form-group>
            </div>

            <form class="row pt-3 pl-2" v-if="selected === 2" @submit.prevent="todos">


              <b-form-group id="cycle" label-for="cycle" class="col-md-2 px-2" label="Seleccione el año">
                <b-form-select required class=" col-md-8 form-control" v-model="medicionY.year">
                  <b-form-select-option v-for="item in years" :value="item" v>
                    {{ item }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>

              <div class="col-md-8 col-sm-12">
                <button @click="awesome1 = !awesome1" type="submit" name="boton" class="btn btn-primary mt-3">
                  Generar reporte
                </button>
              </div>

              <div class="col-md-2 col-sm-12 text-right">
                <button @click="printExcel" type="button" class="btn btn-primary mt-3" id="tooltip">
                  <span class="btn-label"><i class="bx bx-download"></i></span>Descargar tabla a excel
                </button>
                <b-tooltip target="tooltip" placement="left">
                  Descargar reporte
                </b-tooltip>
              </div>

              <div class="pt-4 col-md-3 col-sm-12 px-5">
                <h5>Meta mensual: {{ this.listY[12].monthly_goal }}</h5>
              </div>
              <div class=" pt-4 col-md-3 col-sm-12">
                <h5>Meta anual: {{ this.listY[12].annual_goal }}</h5>
              </div>
              <div class="col-md-6 col-sm-12">

              </div>

              <div class="table-responsive pt-4 px-5" v-if="getRole('Consultar') && awesome1">
                <table class="
                                                                          pt-2
                                                                          table
                                                                          border-bottom
                                                                          divide-y divide-gray-200
                                                                         table-bordered
                                                                          rounded
                                                                        ">
                  <thead class="bg-primary text-light">

                    <tr>

                      <th class="text-center align-middle">Periodo</th>
                      <th class="text-center align-middle">Número de trabajadores</th>
                      <th class="text-center align-middle">Total de accidentes de trabajo mensuales</th>
                      <th class="text-center align-middle">Frecuencia de accidentalidad </th>
                      <th class="text-center align-middle">Cumple</th>

                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    <tr v-for="item in listY">
                      <td class="bg-primary text-center text-white align-middle">
                        {{ item.Periodo }}
                      </td>
                      <td class="text-center align-middle">
                        {{ item.Total_Colaboradores }}
                      </td>
                      <td class="text-center align-middle">
                        <div v-if="item.Accidentes_Mensuales > item.monthly_goal">
                          <p style="color: red;">
                            {{ item.Accidentes_Mensuales }}
                          </p>
                        </div>
                        <div v-else>
                          <p>
                            {{ item.Accidentes_Mensuales }}
                          </p>
                        </div>
                      </td>
                      <td class="text-center align-middle">
                        {{ item.Indicador_Frecuencia }}
                      </td>
                      <td class="text-center align-middle">
                        {{ item.Cumple }}
                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <div v-if="awesome1" class="col-lg-12 pt-3">
                <div class="text-right mb-2">
                  <button @click="downloadMonthlyIndicatorChartImage" type="button" class="btn btn-primary mx-1">
                    <span class="btn-label"><i class="bx bx-download"></i></span>Descargar gráfica
                  </button>
                </div>
                <div class="card">
                  <div class="card-body" dir="ltr">
                    <h4 class="header-title">Gráfica de frecuencia de accidentalidad</h4>
                    <ul>
                      <li style="color:#00707f">Frecuencia de accidentalidad</li>

                    </ul>
                    <p class="sub-header"></p>

                    <Chartist ratio="ct-chart" :data="chartData" :options="chartOptions" type="Line"></Chartist>
                  </div>
                </div>
              </div>

              <div v-if="awesome1" class="col-lg-12 pt-3">
                <div class="text-right mb-2">
                  <button @click="downloadMonthlyAccidentsChartImage" type="button" class="btn btn-primary mx-1">
                    <span class="btn-label"><i class="bx bx-download"></i></span>Descargar gráfica
                  </button>
                </div>
                <div class="card">
                  <div class="card-body" dir="ltr">
                    <h4 class="header-title">Gráfica de total de accidentes de trabajo mensuales</h4>
                    <ul>
                      <li style="color:#1abc9c">Total de accidentes de trabajo mensuales</li>

                    </ul>
                    <p class="sub-header"></p>

                    <Chartist ratio="ct-chart" :data="chartData1" :options="chartOptions" type="Line"></Chartist>
                  </div>
                </div>
              </div>
            </form>

            <form class="row pt-3 pl-2" v-if="selected === 1" @submit.prevent="todos2">

              <b-form-group id="cycle" label-for="cycle" class="col-md-2 px-2" label="Inicio">
                <b-form-select required class=" col-md-8 form-control" v-model="medicionM.start_year">
                  <b-form-select-option v-for="item in years" :value="item">
                    {{ item }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>

              <b-form-group id="cycle" label-for="cycle" class="col-md-2 px-2" label="Fin">
                <b-form-select required class=" col-md-8 form-control" v-model="medicionM.end_year">
                  <b-form-select-option v-for="item in years" :value="item">
                    {{ item }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>


              <div class="col-md-6 col-sm-12">
                <button @click="awesome = !awesome" type="submit" name="boton" class="btn btn-primary mt-3">
                  Generar reporte
                </button>
              </div>

              <div class="table-responsive pt-4 px-5" v-if="getRole('Consultar')">
                <table class="
                                                            pt-2
                                                            table
                                                            border-bottom
                                                            divide-y divide-gray-200
                                                           table-bordered
                                                            rounded
                                                          ">
                  <thead class="bg-primary text-light">

                    <tr>

                      <th class="text-center align-middle">Periodo</th>
                      <th class="text-center align-middle">Número de trabajadores</th>
                      <th class="text-center align-middle">Total de accidentes de trabajo anuales</th>
                      <th class="text-center align-middle">Frecuencia de accidentalidad </th>
                      <th class="text-center align-middle">Meta mensual</th>
                      <th class="text-center align-middle">Meta anual</th>
                      <th class="text-center align-middle">Cumple</th>

                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    <tr v-for="item in listM">
                      <td class=" bg-primary text-center text-white align-middle">
                        {{ item.Periodo }}
                      </td>
                      <td class="text-center align-middle">
                        {{ item.Total_Colaboradores }}
                      </td>
                      <td class=" text-center align-middle">
                        <div v-if="item.Accidentes_year > item.annual_goal">
                          <p style="color: red;">
                            {{ item.Accidentes_year }}
                          </p>
                        </div>
                        <div v-else>
                          <p>
                            {{ item.Accidentes_year }}
                          </p>
                        </div>
                      </td>
                      <td class="text-center align-middle">
                        {{ item.Indicador_Frecuencia }}
                      </td>
                      <td class=" text-center align-middle">
                        {{ item.monthly_goal }}
                      </td>
                      <td class="text-center align-middle">
                        {{ item.annual_goal }}
                      </td>
                      <td class="text-center align-middle">
                        {{ item.Cumple }}
                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <div v-if="awesome" class="col-lg-12 pt-3">
                <div class="text-right mb-2">
                  <button @click="downloadAnnualIndicatorChartImage" type="button" class="btn btn-primary mx-1">
                    <span class="btn-label"><i class="bx bx-download"></i></span>Descargar gráfica
                  </button>
                </div>
                <div class="card">
                  <div class="card-body" dir="ltr">
                    <h4 class="header-title">Gráfica de frecuencia de accidentalidad</h4>
                    <ul>
                      <li style="color:#00707f">Frecuencia de accidentalidad</li>

                    </ul>
                    <p class="sub-header"></p>

                    <Chartist ratio="ct-chart" :data="chartData2" :options="chartOptions" type="Line"></Chartist>
                  </div>
                </div>
              </div>
              <div v-if="awesome" class="col-lg-12 pt-3">
                <div class="text-right mb-2">
                  <button @click="downloadAnnualAccidentsChartImage" type="button" class="btn btn-primary mx-1">
                    <span class="btn-label"><i class="bx bx-download"></i></span>Descargar gráfica
                  </button>
                </div>
                <div class="card">
                  <div class="card-body" dir="ltr">
                    <h4 class="header-title">Gráfica de total de accidentes de trabajo mensuales</h4>
                    <ul>
                      <li style="color:#1abc9c">Total de accidentes de trabajo mensuales</li>

                    </ul>
                    <p class="sub-header"></p>

                    <Chartist ratio="ct-chart" :data="chartData3" :options="chartOptions" type="Line"></Chartist>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>